var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"64","cy":"64","fill":"#c13ccd","r":"64","key":0}),React.createElement("path",{"d":"m82.4 29.4c4.3 2.9 5 4 2.9 7.5-1.5\n2.9-3.3 3.7-5.6 2.9-11.7-4.9-14.6-5.5-19.7-4.3a11.4 11.4 0 0 0 -8 13.6c.6 2 5\n5.1 9.5 7 24.1 9.3 29.7 15.2 27 28.6-4 20.3-30 27-48.9 12.6-3-2.3-3.3-3.3-.8-6.5\n2.9-3.9 3-3.9 12.4.6 10 4.9 15.8 4.5 22.6-1.4 1.9-1.7 3.6-5.1 3.6-7.6\n0-5.6-4.8-9.5-17.6-14.2-13.7-5-19.7-11.2-19.7-20.2 0-9.5 3-14.4 11-19.5 7.8-4.9\n22.9-4.5 31.3 1z","fill":"#fff","pathLength":"1","key":1})]);
}

Logo.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = Logo;

Logo.default = Logo;
